import fb from "./fb.svg";
import tiktok from "./tiktok.svg";
import youtube from "./youtube.svg";
import insta from "./insta.svg";

const Icons =  {
  iconFB: fb,
  iconTiktok: tiktok,
  iconYoutube: youtube,
  iconInsta: insta,


}


export default Icons;